var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftCarot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.265172 7.87804L7.59868 0.757485C7.95225 0.414172 8.5258 0.414172 8.87936 0.757485L9.73478 1.58811C10.088 1.93105 10.0883 2.48651 9.73629 2.83019L3.92419 8.49982L9.73591 14.1698C10.0883 14.5135 10.0876 15.0689 9.7344 15.4119L8.87898 16.2425C8.52542 16.5858 7.95187 16.5858 7.59831 16.2425L0.265172 9.12159C-0.0883908 8.77828 -0.0883908 8.22135 0.265172 7.87804Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCarot);
export default __webpack_public_path__ + "static/media/leftCarot.6b21bfbe87b116945f3785e50de99698.svg";
export { ForwardRef as ReactComponent };